export default __webpack_public_path__ + "static/media/details.82811eff.svg";